'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./YesNoStatus.scss');

var cn = _bind2.default.bind(styles);

var YesNoStatus = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(YesNoStatus, _PureComponent);

  function YesNoStatus() {
    (0, _classCallCheck3.default)(this, YesNoStatus);
    return (0, _possibleConstructorReturn3.default)(this, (YesNoStatus.__proto__ || (0, _getPrototypeOf2.default)(YesNoStatus)).apply(this, arguments));
  }

  (0, _createClass3.default)(YesNoStatus, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          onClick = _props.onClick,
          success = _props.success,
          hasRights = _props.hasRights;
      var t = this.context.t;


      return _react2.default.createElement(
        'span',
        { className: cn(styles.status, className, { hasRights: hasRights, success: success }), onClick: onClick },
        success ? t('Yes') : t('No')
      );
    }
  }]);
  return YesNoStatus;
}(_react.PureComponent), _class.propTypes = {
  className: _propTypes2.default.string,
  hasRights: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  success: _propTypes2.default.bool
}, _class.contextTypes = {
  t: _propTypes2.default.func
}, _class.defaultProps = {
  onClick: _noop3.default
}, _temp);
exports.default = YesNoStatus;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/YesNoStatus/YesNoStatus.js
// module id = 860
// module chunks = 1